.literature {
  color: #666;
  font-size: 13px;
}
.literature.empty {
  font-style: italic;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlBhZ2luYXRpb24ubW9kdWxlLnNhc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRTtFQUNBOztBQUNBO0VBQ0UiLCJzb3VyY2VzQ29udGVudCI6WyIubGl0ZXJhdHVyZVxuICBjb2xvcjogIzY2NlxuICBmb250LXNpemU6IDEzcHhcbiAgJi5lbXB0eVxuICAgIGZvbnQtc3R5bGU6IGl0YWxpY1xuXG4iXX0= */